import React from 'react';
import { useTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import './assets/components.css';
const CustomToolTip = withStyles(theme => ({
  tooltip: {
    backgroundColor: '#222a3e',
    color: 'white',
    boxShadow: theme.shadows[1],
    fontSize: 11,
    maxWidth: '250px',
    maxHeight: '100px',
    overflowY: 'scroll',
    zIndex: '0',
    scrollbarFace: 'red',
    fontFamily: 'Raleway'
  }
}))(Tooltip);
const removeTags = /<[^>]*>?/gm;
const ToolTipHover = ({
  interact = true,
  label,
  text,
  fontSize = '0.75rem',
  textAlign,
  cleanToolTip = false,
  renderDots = false,
  sliceSize = 20
}) => {
  const {
    t
  } = useTranslation();
  const slicedLabel = renderDots && `${label ? label.replace(removeTags, '').slice(0, sliceSize) : t('GENERAL.noDescription')}`;
  if (slicedLabel.length === sliceSize && slicedLabel) {
    slicedLabel.concat('...');
  }
  const content = /*#__PURE__*/React.createElement(CustomToolTip, {
    className: "customScroll",
    title: text ? text.replace(removeTags, '') : '',
    interactive: interact
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: 'Raleway'
    }
  }, slicedLabel || label));
  if (cleanToolTip) {
    return content;
  }
  return /*#__PURE__*/React.createElement("button", {
    style: {
      fontSize: fontSize,
      textAlign: textAlign,
      fontFamily: 'Raleway'
    },
    className: "toolTipButton",
    onClick: e => e.stopPropagation()
  }, content);
};
export { ToolTipHover };